const newsletterPopup = document.querySelector('.newsletter-popup__wrapper');

if (newsletterPopup) {
  const closePopup = () => {
    toggleBodyScrollLock(false);
    newsletterPopup.classList.remove('is-active');
  };

  const onKeydown = (ev) => {
    if (ev.key === 'Escape') closePopup();
  };
  const onBackdrop = (ev) => {
    if (ev.target === newsletterPopup) closePopup();
  };

  document.addEventListener('keydown', onKeydown);
  newsletterPopup.addEventListener('click', onBackdrop);

  attachEvent('.newsletter-popup__close', 'click', closePopup);
  attachEvent('.open-newsletter-popup', 'click', () => {
    toggleBodyScrollLock(true);
    newsletterPopup.classList.add('is-active');
  });

  // **************************************************

  const smsEmailForm = newsletterPopup.querySelector('.sms-email-only')?.querySelector('form');

  if (smsEmailForm) {
    const CONTAINER = '.mod-input, .checkbox, .dropdown, .form-component__item';
    const field = (selector) => smsEmailForm.querySelector(selector).closest('.form-component__item');
    const smsFields = [field('[name="countrycode"]'), field('#newsletter-phone')];
    const emailFields = [field('#newsletter-email')];
    const sharedFields = [field('#check-policy'), smsEmailForm.querySelector('.form-component__submit')];
    const dividers = [...smsEmailForm.querySelectorAll('.form-component__divider')];

    const resetInput = (input) => {
      input[input.type === 'checkbox' ? 'checked' : 'value'] = input.type === 'checkbox' ? false : '';
      smsEmailForm.fv?.resetField(input.name, true);
      input.closest(CONTAINER)?.classList.remove('is-validation-failed');
    };

    const toggleFields = (items, visible) => {
      items.forEach((item) => {
        item.style.display = visible ? '' : 'none';
        if (!visible) item.querySelectorAll('input[name], select[name], textarea[name]').forEach(resetInput);
      });
    };

    const updateVisibility = () => {
      const smsOn = smsEmailForm.querySelector('#newsletter-sms-button').checked;
      const mailOn = smsEmailForm.querySelector('#newsletter-email-button').checked;

      toggleFields(smsFields, smsOn);
      toggleFields(emailFields, mailOn);
      toggleFields([...sharedFields, ...dividers], smsOn || mailOn);
    };

    updateVisibility();
    smsEmailForm
      .querySelectorAll('[name="preferred-media"]')
      .forEach((cb) => cb.addEventListener('change', updateVisibility));
  }

  // **************************************************
  // Default variant: SMS -> phone required, Mail -> email required

  const preferredMediaRadios = newsletterPopup.querySelectorAll('[name="preferred-media"]');
  const preferredMediaForm = preferredMediaRadios[0]?.closest('form');
  const smsRadio = document.getElementById('newsletter-sms');
  const mailRadio = document.getElementById('newsletter-mail');
  const phoneField = preferredMediaForm?.querySelector('#phone');
  const emailField = preferredMediaForm?.querySelector('#email');

  if (preferredMediaForm && smsRadio && mailRadio && phoneField && emailField) {
    const setRequired = (field, required) => {
      field.toggleAttribute('required', required);
      preferredMediaForm.fv?.addField(field.name, {
        validators: {
          notEmpty: { message: field.getAttribute('data-fv-not-empty___message') || 'This field is required' },
        },
      });
      preferredMediaForm.fv?.[required ? 'enableValidator' : 'disableValidator'](field.name, 'notEmpty');
      preferredMediaForm.fv?.revalidateField(field.name);

      if (!required) field.closest('.mod-input')?.classList.remove('is-validation-failed');
    };

    const updateRequiredFields = () => {
      setRequired(phoneField, smsRadio.checked);
      setRequired(emailField, mailRadio.checked);
    };

    preferredMediaRadios.forEach((radio) => radio.addEventListener('change', updateRequiredFields));
    updateRequiredFields();
  }
}
